module.exports = __webpack_public_path__ + "img/avt.198fa8be.png";